import api from './api';
import { ENDPOINTS } from '../constants/apiEndpoints';

export const loginAPI = ({ emailId, loginPassword }) => {
  const loginPayload = {
    username: emailId,
    password: loginPassword
  };

  const requestDTO = {
    data: JSON.stringify(loginPayload),
    target: 'models.auth.Login',
    compressed: false
  };
  return api.post(ENDPOINTS.login.url, requestDTO);
};

export const authorizeAPI = (branchIdEncrypted) => {
  return api.post(ENDPOINTS.authorize.url, {
    data: branchIdEncrypted,
    target: null,
    compressed: null
  });
};
